import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function BookOnline() {
  const steps = [{
    num: '1',
    title: 'Book a cleaning',
    desc: 'Select your preferred date and time online in just a few clicks.'
  }, {
    num: '2',
    title: 'Confirm booking',
    desc: 'Receive an instant confirmation and details about your cleaner.'
  }, {
    num: '3',
    title: "We'll clean it",
    desc: 'Our vetted professionals will make your space shine.'
  }];
  return <section className="w-full bg-white py-20 px-6 md:px-12 overflow-hidden" data-id="element-28">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-29">
        {/* Left Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col" data-id="element-30">
          <div className="flex justify-between items-start mb-12" data-id="element-31">
            <h2 className="text-6xl md:text-8xl font-bebas text-[#1a2744] leading-none tracking-wide" data-id="element-32">
              BOOK
              <br data-id="element-33" />
              ONLINE
            </h2>
            <div className="text-right mt-4" data-id="element-34">
              <span className="font-serif-playfair text-xl text-[#1a2744] italic block" data-id="element-35">
                Fast & Secure
              </span>
              <p className="text-sm text-gray-500 max-w-[200px] mt-2 text-right" data-id="element-36">
                Our seamless booking system makes scheduling your cleaning
                easier than ever before.
              </p>
            </div>
          </div>

          <div className="space-y-8" data-id="element-37">
            {steps.map((step, idx) => <motion.div key={step.num} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.2
          }} className="flex items-start gap-6 border-b border-gray-200 pb-6 last:border-0" data-id="element-38">
                <div className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center flex-shrink-0" data-id="element-39">
                  <span className="font-bebas text-2xl text-gray-400" data-id="element-40">
                    {step.num}
                  </span>
                </div>
                <div data-id="element-41">
                  <h3 className="text-xl font-bold text-[#1a2744] mb-1" data-id="element-42">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-43">{step.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative h-[500px] lg:h-[700px] w-full" data-id="element-44">
          <img src="https://cdn.magicpatterns.com/uploads/duhXLV8WEmmtF3sBiEhEBL/sj-website-home-img5.png" alt="Clean modern living room showcasing Smith and Jengs cleaning results" className="w-full h-full object-cover rounded-sm" loading="lazy" data-id="element-45" />
          {/* Carousel dots mock */}
          <div className="absolute bottom-6 right-6 flex gap-2" data-id="element-46"></div>
        </motion.div>
      </div>
    </section>;
}